import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  Checkbox,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Input,
  Image,
  Loader,
  Button,
  Modal,
  Popup,
  Search,
  Select,
  Table,
  TextArea,
} from "semantic-ui-react";
import "./index.css";
import MetaData from "../../components/MetaData";
import { useDraggable } from "react-use-draggable-scroll";
import _debounce from "lodash/debounce";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import cartReducer from "../Cart/cart.reducer";
import searchReducer from "../Search/search.reducer";
import myCustomersIcon from "../../assets/images/pages/my-customers.png";
import {
  apiAddContact,
  apiAddCustomer,
  apiDeleteContact,
  apiDeleteCustomer,
  apiGetCustomer,
  apiGetCustomersList,
  apiSaveCustomersAndContacts,
  apiUpdateContact,
  apiUpdateCustomer,
} from "./myCustomers.api";
import rightArrow from "../../../src/assets/images/right-transparent.png";
import Papa from "papaparse";
import { customerContactModel, customerSearchDefaultOptions } from "./data";
import NumericInputDiscount from "../../components/NumericInputDiscount";

const StockTransfer = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [customerList, setCustomerList] = useState([]);
  const [formData, setFormData] = useState({ statusId: 0 });
  const [addContactOpen, setAddContactOpen] = useState(false);
  const [openRemoveCustomer, setOpenRemoveCustomer] = useState(false);
  const [openDeleteCustomer, setOpenDeleteCustomer] = useState(false);
  const [isAddCompany, setIsAddCompany] = useState(false);
  const [contactFormData, setContactFormData] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [customerSaved, setCustomerSaved] = useState(false);
  const [contactSaved, setContactSaved] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [onCustomerEdit, setOnCustomerEdit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [openRemoveContact, setOpenRemoveContact] = useState(false);
  const [selectedContact, setSelectedContact] = useState({});
  const [csvUploadOpen, setCsvUploadOpen] = useState(false);
  const [jsonResult, setJsonResult] = useState([]);
  const [jsonResultData, setJsonResultData] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);
  const [customerSearchOptions, setCustomerSearchOptions] = useState(
    customerSearchDefaultOptions
  );
  const [customerSearchKeyword, setCustomerSearchKeyword] = useState("");
  const [customerSearchType, setCustomerSearchType] = useState(null);
  const [customerSearchTypeFullName, setCustomerSearchTypeFullName] =
    useState(null);
  const [isAddContactFromCustomer, setIsAddContactFromCustomer] =
    useState(false);

  const csvRef = useRef();

  const ref = useRef();
  const { events } = useDraggable(ref);

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const [openSearchList, setOpenSearchList] = useState(false);

  const handleCustomerSearchChange = (e) => {
    setOpenSearchList(true);
    if (e.target.value === "" && customerSearchType !== null) {
      setCustomerSearchOptions(customerSearchDefaultOptions);
      setCustomerSearchType(null);
      setCustomerSearchTypeFullName(null);
      getCustomersList("", null);
      setOpenSearchList(false);
    }
    const updatedOptions = customerSearchDefaultOptions.map((item) => ({
      ...item,
      value: (
        <span
          style={{
            color: "#grey",
            fontWeight: "normal",
            fontSize: 16,
          }}
        >
          Search by {item.value}:{" "}
          <span
            style={{
              color: "#000",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            {e.target.value}
          </span>
        </span>
      ),
    }));
    setCustomerSearchKeyword(e.target.value);
    setCustomerSearchOptions(updatedOptions);
  };

  const handleCustomerResultSelect = (e, { result }) => {
    const _type = result.key;
    const _typeFullName = result.title.props.children[1];
    setOpenSearchList(false);
    setCustomerSearchType(_type);
    setCustomerSearchTypeFullName("Search by " + _typeFullName);
    getCustomersList(customerSearchKeyword, _type);
  };

  const onHandleKeyPress = (e) => {
    if (e.key === "Enter" && customerSearchOptions.length > 0) {
      e.preventDefault(); // Prevent default Enter key behavior
      const _type = "All";
      const _typeFullName = "All";

      setOpenSearchList(false);

      setCustomerSearchType(_type);
      setCustomerSearchTypeFullName("Search by " + _typeFullName);
      getCustomersList(customerSearchKeyword, _type);
    }
  };

  function handleChange(dataType, value) {
    let newState = [];
    newState.push(formData);
    let data = newState.map((item, i) => {
      if (i == 0) {
        if (dataType == "useGlobalLabour" && value) {
          item.labourFee = "";
        }
        if (dataType == "useGlobalTravel" && value) {
          item.travelFee = "";
        }
        if (dataType == "useGlobalMarkup" && value) {
          item.markupPercent = "";
        }
        return { ...item, [dataType]: value };
      }
      return item;
    });

    setFormData(data[0]);
  }

  function handleContactChange(dataType, value) {
    let newState = [];
    newState.push(contactFormData);
    let data = newState.map((item, i) => {
      if (i == 0) {
        if (dataType === "companyName" && value) {
          item.id = 0;
          item.customerId = 0;
        }
        if (dataType === "customerId" && value) {
          const customer = customers.find((item) => item.id === value);
          if (customer) item.companyName = customer.companyName;
        }
        if (dataType === "customerId" && !value) {
          item.id = 0;
          item.customerId = 0;
          item.companyName = null;
        }
        return { ...item, [dataType]: value };
      }
      return item;
    });
    setContactFormData(data[0]);
  }

  const getCustomersList = async (
    keyword = "",
    searchType = null,
    isFirstLoad = false
  ) => {
    setSearchLoading(true);
    const companies = await apiGetCustomersList(keyword, searchType);
    if (companies) {
      if (keyword === "") {
        const activeCustomers = companies.filter((item) => item.id > 0);
        setCustomers(activeCustomers);
      }
      const UNASSIGNED_KEY = "Unassigned Contacts";
      const SPECIAL_KEY = "#";

      const groupedCompanies = companies.reduce((acc, company) => {
        const firstChar = company.companyName[0].toUpperCase();

        let groupKey;
        if (company.companyName === "Unassigned") {
          groupKey = UNASSIGNED_KEY;
        } else if (/[A-Z0-9]/.test(firstChar)) {
          groupKey = firstChar;
        } else {
          groupKey = SPECIAL_KEY;
        }

        acc[groupKey] = acc[groupKey] || [];
        acc[groupKey].push(company);
        return acc;
      }, {});

      // Remove "Unassigned Contacts" if the first object in its array has an empty customerContacts array
      if (
        groupedCompanies[UNASSIGNED_KEY] &&
        groupedCompanies[UNASSIGNED_KEY][0].customerContacts.length === 0
      ) {
        delete groupedCompanies[UNASSIGNED_KEY];
      }

      // Sort keys: Numbers (0-9), A-Z, then "#" (if it exists), then "Unassigned Contacts" (if it exists)
      const sortedKeys = Object.keys(groupedCompanies)
        .filter((key) => key !== SPECIAL_KEY && key !== UNASSIGNED_KEY)
        .sort((a, b) =>
          !isNaN(a) && isNaN(b)
            ? -1
            : isNaN(a) && !isNaN(b)
            ? 1
            : a.localeCompare(b)
        );

      // Add "#" if it has values
      if (groupedCompanies[SPECIAL_KEY]?.length) {
        sortedKeys.push(SPECIAL_KEY);
      }

      // Add "Unassigned Contacts" if it exists after filtering
      if (groupedCompanies[UNASSIGNED_KEY]) {
        sortedKeys.push(UNASSIGNED_KEY);
      }

      // Construct final sorted object
      const finalGroupedCompanies = sortedKeys.reduce((sortedAcc, key) => {
        sortedAcc[key] = groupedCompanies[key];
        return sortedAcc;
      }, {});

      const firstCategory = Object.keys(finalGroupedCompanies)[0];
      const firstCustomer = firstCategory
        ? finalGroupedCompanies[firstCategory][0]
        : null;

      if (firstCustomer && isFirstLoad) setSelectedId(firstCustomer.id);

      setCustomerList(finalGroupedCompanies);
      setSearchLoading(false);
    } else {
      showErrorToast("Something went wrong");
      setSearchLoading(false);
    }
  };

  const getCustomerData = async (id = null) => {
    setDataLoading(true);
    const result = await apiGetCustomer(id ? id : selectedId);
    if (result) {
      const customerData = {
        id: result.id,
        userName: result.userName,
        companyName: result.companyName,
        isDeleted: result.isDeleted,
        markupPercent: result.markupPercent
          ? result.markupPercent.toFixed(1)
          : "",
        labourFee: result.labourFee ? result.labourFee.toFixed(2) : "",
        travelFee: result.travelFee ? result.travelFee.toFixed(2) : "",
        discountPercent: result.discountPercent
          ? result.discountPercent.toFixed(1)
          : "",
        useGlobalMarkup: !result.markupPercent ? true : false,
        useGlobalLabour: !result.labourFee ? true : false,
        useGlobalTravel: !result.travelFee ? true : false,
        contactsCount: result.contactsCount,
        customerContacts: result.customerContacts,
        showItemizedInvoice: result.showItemizedInvoice ? true : false,
        requirePurchaseOrderNumber: result.requirePurchaseOrderNumber
          ? true
          : false,
      };

      setOnCustomerEdit(false);
      setFormData(customerData);
      setDataLoading(false);
    } else {
      showErrorToast("Failed to load Customer, please try again");
      setDataLoading(false);
    }
  };

  const onSubmitAddCustomer = async () => {
    setContactSaved(true);
    console.log(contactFormData);
    if (
      (!contactFormData.companyName || contactFormData.companyName === "") &&
      isAddCompany
    ) {
      showErrorToast("Please complete all required fields");
      return false;
    }
    if (!contactFormData.customerId && !isAddCompany) {
      showErrorToast("Please complete all required fields");
      return false;
    }
    if (
      !contactFormData.contactName &&
      (contactFormData.contactNumber || contactFormData.email)
    ) {
      showErrorToast("Please complete all required fields");
      return false;
    }
    const userName = localStorage.getItem("user");
    if (contactFormData.companyName && contactFormData.customerId > 0) {
      if (contactFormData.contactName) {
        if (contactFormData.email) {
          contactFormData.email = contactFormData.email.trim().toLowerCase();
          if (!isValidEmail(contactFormData.email)) {
            showErrorToast("Invalid contact email");
            return false;
          }
        }
      } else {
        showErrorToast("Please complete all required fields");
        return false;
      }
      return onSubmitAddContact(contactFormData.customerId);
    } else {
      if (contactFormData.contactName) {
        if (contactFormData.email) {
          contactFormData.email = contactFormData.email.trim().toLowerCase();
          if (!isValidEmail(contactFormData.email)) {
            showErrorToast("Invalid contact email");
            return false;
          }
        }
      }
    }
    try {
      const contactData = await apiAddCustomer(contactFormData, userName);
      if (contactData) {
        if (contactFormData.contactName) {
          onSubmitAddContact(contactData.id);
        } else {
          getCustomersList();
          if (selectedId !== contactData.id) {
            setSelectedId(contactData.id);
          } else {
            getCustomerData();
          }
          setAddContactOpen(false);
          setContactFormData({});
          setContactSaved(false);
          showSuccessToast(
            <div>
              <i className="check icon" /> Customer Added Successfully
            </div>
          );
          setIsOpen(false);
          setIsLoading(false);
        }
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  const onSubmitAddContact = async (id) => {
    try {
      const contactData = await apiAddContact(contactFormData, id);
      if (contactData) {
        getCustomersList();
        if (selectedId !== id) {
          setSelectedId(id);
        } else {
          getCustomerData();
        }
        setAddContactOpen(false);
        setContactFormData({});
        showSuccessToast(
          <div>
            <i className="check icon" /> Contact Added Successfully
          </div>
        );
        setIsOpen(false);
        setIsLoading(false);
      } else {
        showErrorToast("Something went wrong");
        setIsLoading(false);
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  const onSubmitUpdateCustomer = async () => {
    setCustomerSaved(true);
    if (!formData.companyName || formData.companyName === "") {
      showErrorToast("Company Name field is required");
      return false;
    }
    if (
      !formData.useGlobalLabour &&
      (formData.labourFee === "" || formData.labourFee === null)
    ) {
      showErrorToast("Please complete all required fields");
      return false;
    }
    if (
      !formData.useGlobalTravel &&
      (formData.travelFee === "" || formData.travelFee === null)
    ) {
      showErrorToast("Please complete all required fields");
      return false;
    }
    if (
      !formData.useGlobalMarkup &&
      (formData.markupPercent === "" || formData.markupPercent === null)
    ) {
      showErrorToast("Please complete all required fields");
      return false;
    }

    try {
      const contactData = await apiUpdateCustomer(formData);
      if (contactData) {
        setCustomerSaved(false);
        getCustomersList();
        getCustomerData();
        setAddContactOpen(false);
        setContactFormData({});
        showSuccessToast(
          <div>
            <i className="check icon" /> Customer Updated Successfully
          </div>
        );
        setIsOpen(false);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  const onSubmitUpdateContact = async () => {
    setContactSaved(true);
    if (contactFormData.contactName) {
      if (contactFormData.email) {
        contactFormData.email = contactFormData.email.trim().toLowerCase();
        if (!isValidEmail(contactFormData.email)) {
          showErrorToast("Invalid contact email");
          return false;
        }
      }
    } else {
      showErrorToast("Please complete all required fields");
      return false;
    }
    try {
      const contactData = await apiUpdateContact(contactFormData);
      if (contactData) {
        setContactSaved(false);
        getCustomersList();
        getCustomerData();
        setAddContactOpen(false);
        setContactFormData({});
        showSuccessToast(
          <div>
            <i className="check icon" /> Contact Updated Successfully
          </div>
        );
        setIsOpen(false);
        setIsLoading(false);
      } else {
        showErrorToast("Something went wrong");
        setIsLoading(false);
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  const onDeleteCustomer = async (includeContacts) => {
    setIsLoading(true);
    try {
      const customerData = await apiDeleteCustomer(
        includeContacts,
        selectedCustomer.id
      );
      if (customerData) {
        getCustomersList();
        showSuccessToast(
          <div>
            <i className="check icon" /> Customer Deleted Successfully
          </div>
        );
        setSelectedCustomer({});
        setOpenRemoveCustomer(false);
        setOpenDeleteCustomer(false);
        setIsLoading(false);
      } else {
        showErrorToast("Something went wrong");
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  const onDeleteContact = async () => {
    setIsLoading(true);
    try {
      const contactData = await apiDeleteContact(selectedContact);
      if (contactData) {
        getCustomersList();
        getCustomerData();
        showSuccessToast(
          <div>
            <i className="check icon" /> Contact Deleted Successfully
          </div>
        );
        setSelectedContact({});
        setOpenRemoveContact(false);
        setIsLoading(false);
      } else {
        showErrorToast("Something went wrong");
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const userName = localStorage.getItem("user");
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          let resultData = result.data;

          resultData.map(async (customer) => {
            customer.id = 0;
            customer.isDeleted = false;
            customer.userName = userName;
            customer.companyName = customer["Customer Name (required)"]
              ? customer["Customer Name (required)"].trim()
              : "";
            customer.customerName = customer["Customer Name (required)"]
              ? customer["Customer Name (required)"].trim()
              : "";
            customer.contactName = customer["Contact Name"]
              ? customer["Contact Name"].trim()
              : "";
            customer.contactNumber = customer["Contact Number"];
            customer.email = customer["Contact Email"];
            customer.discountPercent =
              customer["Customer Specific Discount (%)"];
            customer.useGlobalMarkup = customer["Customer Specific Markup (%)"]
              ? false
              : true;
            customer.markupPercent = customer["Customer Specific Markup (%)"];
            customer.useGlobalLabour = customer["Labour Fee ($)"]
              ? true
              : false;
            customer.labourFee = customer["Labour Fee ($)"];
            customer.useGlobalTravel = customer["Travel Fee ($)"]
              ? true
              : false;
            customer.travelFee = customer["Travel Fee ($)"];
            if (customer.email) {
              customer.email = customer.email.trim().toLowerCase();
              if (!isValidEmail(customer.email)) {
                customer.hasInvalidEmail = true;
              }
            }
          });

          console.log(resultData);

          let data = resultData.filter((obj) => {
            return (
              (obj.customerName !== undefined &&
                obj.customerName !== null &&
                obj.customerName !== "") ||
              (obj.contactName !== undefined &&
                obj.contactName !== null &&
                obj.contactName !== "") ||
              (obj.contactNumber !== undefined &&
                obj.contactNumber !== null &&
                obj.contactNumber !== "") ||
              (obj.email !== undefined &&
                obj.email !== null &&
                obj.email !== "")
            );
          });

          let list = data.reduce((result, currentItem) => {
            currentItem.customerId = 0;

            const group = result.find(
              (groupItem) =>
                groupItem.companyName.toLowerCase() ===
                  currentItem.companyName.toLowerCase() &&
                groupItem.contactName.toLowerCase() ===
                  currentItem.contactName.toLowerCase()
            );

            if (group) {
              group.isDeleted = false;
              group.userName = userName;
              group.companyName = currentItem.companyName;
              group.customerName = currentItem.customerName;
              group.discountPercent = currentItem.discountPercent
                ? currentItem.discountPercent
                : group.discountPercent;
              group.markupPercent = currentItem.markupPercent
                ? currentItem.markupPercent
                : group.markupPercent;
              group.labourFee = currentItem.labourFee
                ? currentItem.labourFee
                : group.labourFee;
              group.travelFee = currentItem.travelFee
                ? currentItem.travelFee
                : group.travelFee;
              group.customerContacts.push(currentItem);
            } else {
              result.push({
                isDeleted: false,
                userName: userName,
                companyName: currentItem.companyName,
                customerName: currentItem.customerName,
                contactName: currentItem.contactName,
                contactNumber: currentItem.contactNumber,
                email: currentItem.email,
                discountPercent: currentItem.discountPercent,
                useGlobalMarkup: currentItem.useGlobalMarkup,
                markupPercent: currentItem.markupPercent,
                useGlobalLabour: currentItem.useGlobalLabour,
                labourFee: currentItem.labourFee,
                useGlobalTravel: currentItem.useGlobalTravel,
                travelFee: currentItem.travelFee,
                useGlobalTravel: currentItem.useGlobalTravel,
                hasInvalidEmail: currentItem.hasInvalidEmail,
                customerContacts: [currentItem],
              });
            }

            return result;
          }, []);

          list.map((obj) => {
            data.map((customer) => {
              if (
                obj.companyName.toLowerCase() ===
                customer.companyName.toLowerCase()
              ) {
                obj.discountPercent = customer.discountPercent
                  ? customer.discountPercent
                  : obj.discountPercent;
                obj.markupPercent = customer.markupPercent
                  ? customer.markupPercent
                  : obj.markupPercent;
                obj.labourFee = customer.labourFee
                  ? customer.labourFee
                  : obj.labourFee;
                obj.travelFee = customer.travelFee
                  ? customer.travelFee
                  : obj.travelFee;
              }
            });
          });

          // Handle decimals for customer specific fields
          list.map((obj) => {
            obj.discountPercent = isNumber(obj.discountPercent)
              ? parseFloat(obj.discountPercent).toFixed(1)
              : obj.discountPercent;
            obj.markupPercent = isNumber(obj.markupPercent)
              ? parseFloat(obj.markupPercent).toFixed(1)
              : obj.markupPercent;
            obj.labourFee = isNumber(obj.labourFee)
              ? parseFloat(obj.labourFee).toFixed(2)
              : obj.labourFee;
            obj.travelFee = isNumber(obj.travelFee)
              ? parseFloat(obj.travelFee).toFixed(2)
              : obj.travelFee;
          });

          setJsonResultData(list);
          setJsonResult(list);
        },
        header: true, // Set this to true if your CSV file has headers
      });
    }
  };

  function isNumber(value) {
    return !isNaN(value) && value.trim() !== "";
  }

  // Error checker for number fields
  function hasError(quantity) {
    let hasError = false;

    if (quantity === "") return false;
    if (isNaN(quantity)) {
      hasError = true;
    }
    if (!Number.isFinite(Number(parseFloat(quantity)))) {
      hasError = true;
    }
    if (quantity < 0) {
      hasError = true;
    }
    return hasError;
  }

  const generateCSV = () => {
    const csvContent = [
      [
        "Customer Name (required)",
        "Contact Name",
        "Contact Number",
        "Contact Email",
        "Customer Specific Discount (%)",
        "Customer Specific Markup (%)",
        "Labour Fee ($)",
        "Travel Fee ($)",
      ],
      // Add more data rows here
    ];

    const csvRows = csvContent.map((row) => row.join(",")); // Join each row with a comma

    return csvRows.join("\n"); // Join rows with a newline character
  };

  const onSaveCustomersAndContacts = async () => {
    // Validate all payload data for errors
    let errorCount = 0;
    jsonResult.map((data) => {
      if (hasError(data.markupPercent)) errorCount++;
      if (hasError(data.labourFee)) errorCount++;
      if (hasError(data.travelFee)) errorCount++;
      if (hasError(data.discountPercent)) errorCount++;
    });
    if (errorCount > 0) {
      showErrorToast("Please correct all data before importing");
      return false;
    }

    let hasDataError = false;
    jsonResult.map((data) => {
      if (!data.customerName || data.hasInvalidEmail) {
        hasDataError = true;
      }
    });

    if (hasDataError) {
      showErrorToast("Please correct all data before importing");
      return false;
    }

    let groupedCustomers = jsonResultData.reduce((result, currentItem) => {
      currentItem.customerId = 0;

      const group = result.find(
        (groupItem) =>
          groupItem.companyName.toLowerCase() ===
          currentItem.companyName.toLowerCase()
      );

      if (group) {
        group.customerContacts.push(currentItem);
      } else {
        result.push(currentItem);
      }

      return result;
    }, []);

    let postData = groupedCustomers.map((obj) =>
      filterObject(obj, customerContactModel)
    );

    setIsLoading(true);
    setCustomersLoading(true);
    setOnCustomerEdit(false);
    try {
      const data = await apiSaveCustomersAndContacts(postData);
      if (data) {
        showSuccessToast(
          <div>
            <i className="check icon" /> Customers and Contacts Updated
            Successfully
          </div>
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        showErrorToast("Something went wrong");
        setCustomersLoading(false);
        setIsLoading(false);
      }
    } catch {
      showErrorToast("Something went wrong");
      setCustomersLoading(false);
      setIsLoading(false);
    }
  };

  // Function to filter objects based on the given model
  const filterObject = (obj, model) => {
    return Object.keys(model).reduce((acc, key) => {
      if (Array.isArray(model[key]) && Array.isArray(obj[key])) {
        // Recursively filter arrays of objects
        acc[key] = obj[key].map((item) => filterObject(item, model[key][0]));
      } else if (obj[key] !== undefined) {
        // Keep only keys present in the model
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };

  useEffect(() => {
    if (selectedId != "") {
      setFormData(null);
      getCustomerData();
    }
  }, [selectedId]);

  useEffect(() => {
    const accountType = localStorage.getItem("accountType");
    const userType = localStorage.getItem("userType");
    if (userType === "4" || accountType === "2" || accountType === "3") {
      props.history.push("/");
    }

    const delayDebounceFn = setTimeout(async () => {
      getCustomersList("", null, true);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, []);

  const handleDiscountInput = (event) => {
    if (event.target.value === "") {
      handleChange("discountPercent", "");
    }
  };

  const handleClearDiscount = () => {
    handleChange("discountPercent", "");
  };

  const DiscountInput = () => {
    return (
      <div className="quantity-form">
        <Grid columns="equal">
          <Grid.Column width={16}>
            <Form.Field>
              <div style={{ marginBottom: 10 }}>
                <NumericInputDiscount
                  style={{
                    input: {
                      padding: 5,
                      textAlign: "left",
                    },
                  }}
                  onKeyDownHandler={(e) => {
                    if (e.key === "Enter") {
                      handleChange("discountPercent", e.target.value);
                    }
                  }}
                  onBlurHandler={(e) => {
                    handleChange("discountPercent", e.target.value);
                  }}
                  onInputHandler={handleDiscountInput}
                  onClearHandler={handleClearDiscount}
                  name="quantity"
                  min={0}
                  max={100}
                  maxLength={6}
                  className="form-control"
                  precision={2}
                  step={1}
                  value={formData?.discountPercent}
                />
              </div>
            </Form.Field>
          </Grid.Column>
        </Grid>
      </div>
    );
  };

  const NumericInputChecker = (event, decimalPlaces = 2) => {
    const { key, target } = event;
    const inputValue = target.value;
    console.log(inputValue);

    // Check if there is already a decimal point
    const hasDecimal = inputValue.includes(".");
    const decimalIndex = inputValue.indexOf(".");
    const isAfterDecimal =
      decimalIndex !== -1 && target.selectionStart > decimalIndex;
    const digitsAfterDecimal = isAfterDecimal
      ? inputValue.slice(decimalIndex + 1).length
      : 0;

    // Allow control keys like Backspace, Delete, and Arrow keys
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    // Handle input conditions
    if (
      // Allow numeric keys (0-9) if they don't exceed the allowed decimal places
      (!isNaN(key) &&
        (!isAfterDecimal || digitsAfterDecimal < decimalPlaces)) ||
      // Allow essential control keys
      allowedKeys.includes(key) ||
      // Allow one decimal point
      (key === "." && !hasDecimal)
    ) {
      return; // Allow input if conditions are met
    }

    // Prevent all other keys
    event.preventDefault();
  };

  const customerListGrouped = Object.entries(customerList)?.map(
    ([category, list], index) => (
      <div style={{ marginTop: index === 0 ? 0 : 18 }}>
        <span
          style={{
            fontSize: 18,
            marginLeft: 0,
            fontWeight: "bolder",
            color: "#66CC23",
          }}
        >
          {category}
        </span>
        {list?.map((data, i) => {
          return (
            <Card
              className={
                selectedId === data?.id ? "job-card active" : "job-card"
              }
              style={{
                marginTop: 10,
                cursor: "default",
                minWidth: 185,
                borderRadius: 10,
                marginBottom: "0px !important",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.3)",
                position: "relative", // Ensure relative positioning
                cursor: "pointer",
              }}
            >
              <Card.Content style={{ cursor: "pointer" }}>
                <Grid columns={2} className="job-management">
                  <Grid.Row style={{ paddingTop: 5 }}>
                    <Grid.Column
                      width={13}
                      style={{ paddingTop: 6, paddingBottom: 6 }}
                      onClick={() => {
                        if (selectedId !== data?.id) {
                          setSelectedId(data.id);
                        } else {
                          setSelectedId("");
                          setFormData(null);
                        }
                      }}
                    >
                      <b>
                        <Card.Description>{data.companyName}</Card.Description>
                      </b>
                    </Grid.Column>
                    <Grid.Column
                      width={3}
                      style={{
                        paddingTop: 6.5,
                        paddingBottom: 6,
                        paddingRight: 5,
                      }}
                    >
                      {data.id !== -1 ? (
                        <div style={{ fontSize: 16, textAlign: "right" }}>
                          <Icon
                            style={{ marginRight: 8, color: "red" }}
                            link
                            name="trash"
                            onClick={() => {
                              setSelectedCustomer(data);
                              setOpenRemoveCustomer(true);
                            }}
                          />
                        </div>
                      ) : null}
                    </Grid.Column>
                    <Grid.Column
                      width={16}
                      style={{
                        paddingTop: 10,
                        paddingBottom: 0,
                        paddingRight: 18,
                      }}
                      onClick={() => {
                        if (selectedId !== data?.id) {
                          setSelectedId(data.id);
                        } else {
                          setSelectedId("");
                          setFormData(null);
                        }
                      }}
                    >
                      <div
                        style={{
                          fontSize: 16,
                          textAlign: "right",
                          color: data.contactsCount > 0 ? "#66CC23" : "#AFABAB",
                        }}
                      >
                        <Icon
                          style={{
                            marginRight: 8,
                            color: data.contactsCount > 0 ? "#66CC23" : "",
                          }}
                          link
                          name="user"
                        />
                        <span>{data.contactsCount}</span>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
            </Card>
          );
        })}
      </div>
    )
  );

  return (
    <React.Fragment>
      <MetaData title="My Customers" />
      <Modal size="tiny" open={addContactOpen}>
        <Modal.Header>
          {!contactFormData?.id ? "ADD NEW" : "EDIT"} CONTACT
        </Modal.Header>
        <Modal.Content>
          <Form size="tiny" style={{ fontSize: 14 }}>
            {!contactFormData?.id ? (
              <>
                {!isAddCompany ? (
                  <>
                    {!isAddContactFromCustomer ? (
                      <Form.Field required>
                        <label>Company Name</label>
                        <Grid>
                          <Grid.Column width={12} style={{ paddingRight: 0 }}>
                            <Dropdown
                              className={
                                (contactFormData?.companyName === "" ||
                                  contactFormData?.companyName === null ||
                                  !contactFormData?.companyName) &&
                                !contactFormData?.customerId &&
                                contactSaved
                                  ? "error"
                                  : ""
                              }
                              placeholder="Company Name"
                              search
                              selection
                              options={customers}
                              style={{ width: "100%" }}
                              value={contactFormData.customerId}
                              onChange={(e, data) =>
                                handleContactChange("customerId", data.value)
                              }
                            />
                          </Grid.Column>
                          <Grid.Column width={4} style={{ paddingRight: 0 }}>
                            <Button
                              size="tiny"
                              onClick={() => {
                                handleContactChange("customerId", null);
                                setIsAddCompany(true);
                              }}
                              style={{ height: "100%" }}
                            >
                              ADD NEW
                            </Button>
                          </Grid.Column>
                        </Grid>
                      </Form.Field>
                    ) : (
                      <Form.Field>
                        <label>Company Name</label>
                        <Input
                          value={formData?.companyName}
                          style={{ pointerEvents: "none", opacity: 0.9 }}
                        />
                      </Form.Field>
                    )}
                  </>
                ) : (
                  <Form.Field required>
                    <label>Company Name</label>
                    <Grid>
                      <Grid.Column width={12} style={{ paddingRight: 0 }}>
                        <Input
                          className={
                            (contactFormData?.companyName === "" ||
                              contactFormData?.companyName === null) &&
                            contactSaved
                              ? "error"
                              : ""
                          }
                          placeholder="Company Name"
                          value={contactFormData?.companyName}
                          onChange={(e, data) =>
                            handleContactChange("companyName", data.value)
                          }
                        />
                      </Grid.Column>
                      <Grid.Column width={4} style={{ paddingRight: 0 }}>
                        <Button
                          size="tiny"
                          onClick={() => {
                            handleContactChange("companyName", null);
                            setIsAddCompany(false);
                          }}
                        >
                          CANCEL
                        </Button>
                      </Grid.Column>
                    </Grid>
                  </Form.Field>
                )}
              </>
            ) : null}
            <Form.Field>
              <label>Contact Name</label>
              <Input
                className={
                  contactSaved &&
                  contactFormData?.customerId &&
                  !contactFormData?.contactName
                    ? "error"
                    : contactSaved &&
                      !contactFormData.contactName &&
                      (contactFormData.contactNumber || contactFormData.email)
                    ? "error"
                    : ""
                }
                disabled={
                  (contactFormData?.companyName === "" ||
                    !contactFormData?.companyName) &&
                  !contactFormData?.customerId
                }
                placeholder="Contact Name"
                value={contactFormData?.contactName}
                onChange={(e, data) =>
                  handleContactChange("contactName", data.value)
                }
              />
              {contactSaved &&
              contactFormData?.customerId &&
              !contactFormData?.contactName ? (
                <div style={{ padding: 3 }}>
                  <span style={{ color: "red" }}>This field is required</span>
                </div>
              ) : contactSaved &&
                !contactFormData.contactName &&
                (contactFormData.contactNumber || contactFormData.email) ? (
                <div style={{ padding: 3 }}>
                  <span style={{ color: "red" }}>This field is required</span>
                </div>
              ) : null}
            </Form.Field>
            <Form.Field>
              <label>Phone Number</label>
              <Input
                disabled={
                  (contactFormData?.companyName === "" ||
                    !contactFormData?.companyName) &&
                  !contactFormData?.customerId
                }
                placeholder="Phone Number"
                value={contactFormData?.contactNumber}
                onChange={(e, data) =>
                  handleContactChange("contactNumber", data.value)
                }
              />
            </Form.Field>
            <Form.Field>
              <label>Contact Email</label>
              <Input
                disabled={
                  (contactFormData?.companyName === "" ||
                    !contactFormData?.companyName) &&
                  !contactFormData?.customerId
                }
                className={
                  !isValidEmail(
                    contactFormData?.email ? contactFormData?.email : ""
                  ) &&
                  contactSaved &&
                  contactFormData?.companyName &&
                  contactFormData?.email
                    ? "error"
                    : ""
                }
                placeholder="Contact Email"
                value={contactFormData?.email}
                onChange={(e, data) => handleContactChange("email", data.value)}
              />
              {!isValidEmail(
                contactFormData?.email ? contactFormData?.email : ""
              ) &&
              contactSaved &&
              contactFormData?.companyName &&
              contactFormData?.email ? (
                <div style={{ padding: 3 }}>
                  <span style={{ color: "red" }}>Invalid contact email</span>
                </div>
              ) : null}
            </Form.Field>
            <Grid style={{ marginTop: 20 }}>
              <Grid.Column width={8} style={{ paddingRight: 5 }}>
                <Button
                  size="tiny"
                  style={{
                    width: "100%",
                    marginLeft: "auto",
                  }}
                  onClick={() => {
                    setAddContactOpen(false);
                    setContactSaved(false);
                    setContactFormData({});
                  }}
                >
                  CANCEL
                </Button>
              </Grid.Column>
              <Grid.Column width={8} style={{ paddingLeft: 5 }}>
                <Button
                  size="tiny"
                  style={{
                    width: "100%",
                    backgroundColor: "rgb(102, 204, 35)",
                    color: "#fff",
                    marginLeft: "auto",
                  }}
                  onClick={() => {
                    if (!contactFormData.id) {
                      onSubmitAddCustomer();
                    } else {
                      onSubmitUpdateContact();
                    }
                  }}
                >
                  SAVE
                </Button>
              </Grid.Column>
            </Grid>
          </Form>
        </Modal.Content>
      </Modal>
      <Modal
        size="mini"
        open={openRemoveCustomer}
        onClose={() => setOpenRemoveCustomer(false)}
      >
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Are you sure <br /> you want to delete customer?
            <br />
            <br />
            {selectedCustomer.companyName}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenRemoveCustomer(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            onClick={() => {
              if (selectedCustomer.customerContacts?.length > 0) {
                setOpenRemoveCustomer(false);
                setTimeout(() => {
                  setOpenDeleteCustomer(true);
                }, 300);
              } else {
                onDeleteCustomer(false);
              }
            }}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal
        size="mini"
        open={openDeleteCustomer}
        onClose={() => setOpenDeleteCustomer(false)}
      >
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Do you want to delete all contacts <br />
            attached to {selectedCustomer.companyName}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenDeleteCustomer(false)}>CANCEL</Button>
          <Button onClick={() => onDeleteCustomer(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            onClick={() => onDeleteCustomer(true)}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal
        size="mini"
        open={openRemoveContact}
        onClose={() => setOpenRemoveContact(false)}
      >
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Are you sure <br /> you want to delete contact?
            <br />
            <br />
            {selectedContact.contactName}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenRemoveContact(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            onClick={() => onDeleteContact()}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal
        className="hosemaker-modal"
        open={csvUploadOpen}
        onClose={() => setCsvUploadOpen(false)}
      >
        <Modal.Header>IMPORT A FILE</Modal.Header>
        <Modal.Content>
          <Grid style={{ margin: 0 }}>
            <Grid.Column
              width={16}
              style={{
                minHeight: 400,
                maxHeight: 400,
                overflowY: "auto",
              }}
            >
              <Table sortable celled fixed>
                <Table.Header
                  style={{ fontSize: 12, paddingLeft: 0, paddingRight: 0 }}
                >
                  <Table.Row>
                    <Table.HeaderCell textAlign="center" width={2}>
                      Customer Name (required)
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Contact Name
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Contact Number
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Contact Email
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      textAlign="center"
                      style={{ paddingLeft: 0, paddingRight: 0, width: 185 }}
                    >
                      Customer Specific Discount (%)
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      textAlign="center"
                      style={{ paddingLeft: 0, paddingRight: 0, width: 180 }}
                    >
                      Customer Specific Markup (%)
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Labour Fee ($)
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Travel Fee ($)
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body style={{ fontSize: 13 }}>
                  {jsonResult.map(
                    ({
                      customerName,
                      markupPercent,
                      labourFee,
                      travelFee,
                      discountPercent,
                      contactName,
                      contactNumber,
                      email,
                      hasInvalidEmail,
                    }) => (
                      <Table.Row key={contactName}>
                        <Table.Cell
                          textAlign="center"
                          style={{
                            border: !customerName ? "solid 1px red" : "",
                          }}
                        >
                          {!customerName ? (
                            <Popup
                              content={"Customer Name is required"}
                              trigger={
                                <div style={{ width: "100%", height: "100%" }}>
                                  {customerName ? (
                                    customerName
                                  ) : (
                                    <span>&nbsp;</span>
                                  )}
                                </div>
                              }
                              position="top center"
                              inverted
                            />
                          ) : (
                            customerName
                          )}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {contactName}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {contactNumber}
                        </Table.Cell>
                        <Table.Cell
                          textAlign="center"
                          style={{
                            border: hasInvalidEmail ? "solid 1px red" : "",
                          }}
                        >
                          {hasInvalidEmail ? (
                            <Popup
                              content={"Invalid contact email"}
                              trigger={<span>{email}</span>}
                              position="top center"
                              inverted
                            />
                          ) : (
                            email
                          )}
                        </Table.Cell>
                        <Table.Cell
                          textAlign="center"
                          style={{
                            border: hasError(discountPercent)
                              ? "solid 2.5px red"
                              : "",
                          }}
                        >
                          {/* Show popup message for data errors */}
                          {!Number.isFinite(
                            Number(parseFloat(discountPercent))
                          ) ? (
                            <Popup
                              content={"Customer Discount must be a number"}
                              trigger={<div>{discountPercent}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : isNaN(discountPercent) ? (
                            <Popup
                              content={"Customer Discount must be a number"}
                              trigger={<div>{discountPercent}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : discountPercent < 0 ? (
                            <Popup
                              content={"Customer Discount can't be negative"}
                              trigger={<div>{discountPercent}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : (
                            discountPercent
                          )}
                        </Table.Cell>
                        <Table.Cell
                          textAlign="center"
                          style={{
                            border: hasError(markupPercent)
                              ? "solid 2.5px red"
                              : "",
                          }}
                        >
                          {/* Show popup message for data errors */}
                          {!Number.isFinite(
                            Number(parseFloat(markupPercent))
                          ) ? (
                            <Popup
                              content={
                                "Customer Specific Markup must be a number"
                              }
                              trigger={
                                <div style={{ width: "100%", height: "100%" }}>
                                  {markupPercent ? (
                                    markupPercent
                                  ) : (
                                    <span>&nbsp;</span>
                                  )}
                                </div>
                              }
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : isNaN(markupPercent) ? (
                            <Popup
                              content={
                                "Customer Specific Markup must be a number"
                              }
                              trigger={<div>{markupPercent}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : markupPercent < 0 ? (
                            <Popup
                              content={
                                "Customer Specific Markup can't be negative"
                              }
                              trigger={<div>{markupPercent}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : (
                            markupPercent
                          )}
                        </Table.Cell>
                        <Table.Cell
                          textAlign="center"
                          style={{
                            border: hasError(labourFee)
                              ? "solid 2.5px red"
                              : "",
                          }}
                        >
                          {/* Show popup message for data errors */}
                          {!Number.isFinite(Number(parseFloat(labourFee))) ? (
                            <Popup
                              content={"Labour Fee must be a number"}
                              trigger={<div>{labourFee}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : isNaN(labourFee) ? (
                            <Popup
                              content={"Labour Fee must be a number"}
                              trigger={<div>{labourFee}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : labourFee < 0 ? (
                            <Popup
                              content={"Labour Fee can't be negative"}
                              trigger={<div>{labourFee}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : (
                            labourFee
                          )}
                        </Table.Cell>
                        <Table.Cell
                          textAlign="center"
                          style={{
                            border: hasError(travelFee)
                              ? "solid 2.5px red"
                              : "",
                          }}
                        >
                          {/* Show popup message for data errors */}
                          {!Number.isFinite(Number(parseFloat(travelFee))) ? (
                            <Popup
                              content={"Travel Fee must be a number"}
                              trigger={<div>{travelFee}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : isNaN(travelFee) ? (
                            <Popup
                              content={"Travel Fee must be a number"}
                              trigger={<div>{travelFee}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : travelFee < 0 ? (
                            <Popup
                              content={"Travel Fee can't be negative"}
                              trigger={<div>{travelFee}</div>}
                              position="top center"
                              inverted
                              style={{ textAlign: "center" }}
                            />
                          ) : (
                            travelFee
                          )}
                        </Table.Cell>
                      </Table.Row>
                    )
                  )}
                </Table.Body>
              </Table>
            </Grid.Column>
            <Grid.Column width={5} style={{ paddingRight: 5 }}>
              <Button
                size="tiny"
                onClick={() => {
                  const csvData = generateCSV();
                  const blob = new Blob([csvData], { type: "text/csv" });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = "Customer Contact Bulk Upload Template.csv";
                  a.click();
                  URL.revokeObjectURL(url);
                }}
              >
                DOWNLOAD TEMPLATE
              </Button>
            </Grid.Column>
            <Grid.Column
              width={11}
              style={{ paddingLeft: 5, textAlign: "right" }}
            >
              <Button
                size="tiny"
                color="youtube"
                onClick={() => {
                  setCsvUploadOpen(false);
                  setJsonResult([]);
                }}
                style={{ marginRight: 10 }}
              >
                CANCEL
              </Button>
              <Button size="tiny" onClick={() => csvRef.current.click()}>
                LOAD NEW FILE
              </Button>
              <input
                ref={csvRef}
                type="file"
                hidden
                onChange={handleFileChange}
              />
              <Button
                disabled={jsonResult.length === 0 || isLoading}
                size="tiny"
                style={{
                  backgroundColor: "rgb(102, 204, 35)",
                  color: "#fff",
                  marginLeft: "auto",
                }}
                onClick={() => onSaveCustomersAndContacts()}
              >
                {!isLoading ? "IMPORT" : "IMPORTING..."}
              </Button>
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
      <Grid
        columns={3}
        divided
        className="my-customers"
        style={{ marginTop: -30 }}
      >
        <Grid.Row style={{ paddingTop: 5, zIndex: 1 }}>
          <Grid.Column width={16} style={{ paddingRight: 0 }}>
            <h3 style={{ marginLeft: 20 }}>
              <img
                src={myCustomersIcon}
                style={{
                  width: 30,
                  height: 30,
                  marginTop: -5,
                  marginRight: 8,
                }}
              />
              My Customers
            </h3>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ paddingTop: 0 }}>
          <Grid.Column
            width={4}
            className="transfer-list-section"
            style={{ paddingRight: 0 }}
          >
            <div
              className={
                customerSearchTypeFullName === null
                  ? "customer-search-box-nosearch"
                  : "customer-search-box"
              }
            >
              <Search
                placeholder="Search for your customers"
                results={customerSearchOptions.map((item) => ({
                  title: item.value,
                  key: item.key,
                }))}
                onSearchChange={handleCustomerSearchChange}
                onResultSelect={handleCustomerResultSelect}
                onKeyPress={onHandleKeyPress}
                open={openSearchList}
                onBlur={() =>
                  setTimeout(() => {
                    setOpenSearchList(false);
                  }, 100)
                }
                value={customerSearchKeyword}
              />
              {customerSearchTypeFullName && (
                <div className="customer-search-type">
                  {customerSearchTypeFullName}
                </div>
              )}
            </div>
            <hr />
            <div
              className="transfer-status"
              style={{ paddingRight: "0px !important" }}
            >
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column
                    width={16}
                    style={{ paddingTop: 0, paddingBottom: 10 }}
                  >
                    <div>
                      <Button
                        className="active-status"
                        size="small"
                        style={{
                          width: "100%",
                          padding: 11,
                        }}
                        onClick={() => {
                          setIsAddContactFromCustomer(false);
                          setIsAddCompany(false);
                          setContactSaved(false);
                          setOnCustomerEdit(false);
                          setAddContactOpen(true);
                        }}
                      >
                        <Icon
                          name="add"
                          style={{ color: "#fff", marginLeft: -15 }}
                        />
                        Add New Contact
                      </Button>
                    </div>
                    <div>
                      <Button
                        className="default-status"
                        size="small"
                        style={{
                          width: "100%",
                          padding: 11,
                        }}
                        onClick={() => {
                          setOnCustomerEdit(false);
                          setCsvUploadOpen(true);
                        }}
                      >
                        Bulk Upload Contacts
                      </Button>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            <div className="transfer-list">
              <div style={{ position: "absolute", top: 300, left: 80 }}>
                {searchLoading ? (
                  <Loader
                    active
                    className="workaround"
                    size="large"
                    inline="centered"
                  >
                    Loading Customers...
                  </Loader>
                ) : null}
              </div>
              {!searchLoading && Object.keys(customerList).length === 0 && (
                <div
                  style={{
                    textAlign: "center",
                    paddingTop: 100,
                    paddingRight: 20,
                    color: "#AFABAB",
                    fontSize: 19,
                  }}
                >
                  <span>No Customers Found</span>
                </div>
              )}
              <div
                {...events}
                ref={ref}
                className="inventory-list-scroll"
                disabled={searchLoading}
                style={{ opacity: searchLoading ? 0.2 : 1, paddingTop: 5 }}
              >
                {customerListGrouped}
              </div>
            </div>
          </Grid.Column>
          {!formData?.id ? (
            <Grid.Column width={12} style={{ paddingRight: 0 }}></Grid.Column>
          ) : (
            <Grid.Column width={12} style={{ paddingRight: 0 }}>
              <Grid>
                <Grid.Column width={8}>
                  <div style={{ minHeight: 43.11, paddingTop: 5 }}>
                    {!onCustomerEdit ? (
                      <h2 style={{ fontWeight: "bolder" }}>
                        {formData?.companyName}
                      </h2>
                    ) : (
                      <Input
                        className={
                          (formData?.companyName === "" ||
                            formData?.companyName === null ||
                            !formData?.companyName) &&
                          customerSaved
                            ? "customer-input error"
                            : "customer-input"
                        }
                        size="tiny"
                        style={{ padding: 0 }}
                        value={formData?.companyName}
                        onChange={(e, data) =>
                          handleChange("companyName", data.value)
                        }
                      />
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column width={8}>
                  {formData?.id !== -1 ? (
                    <div className="job-actions" style={{ textAlign: "right" }}>
                      {!onCustomerEdit ? (
                        <Button
                          className="default-status"
                          style={{
                            paddingLeft: 15,
                            paddingRight: 15,
                            minWidth: 130,
                          }}
                          size="small"
                          onClick={() => setOnCustomerEdit(true)}
                        >
                          Edit
                        </Button>
                      ) : (
                        <>
                          <Button
                            className="active-status"
                            style={{
                              paddingLeft: 15,
                              paddingRight: 15,
                              minWidth: 130,
                            }}
                            size="small"
                            onClick={() => onSubmitUpdateCustomer()}
                          >
                            Confirm
                          </Button>
                          <Button
                            className="default-status"
                            style={{
                              paddingLeft: 15,
                              paddingRight: 15,
                              minWidth: 130,
                            }}
                            size="small"
                            onClick={() => {
                              getCustomerData();
                              setOnCustomerEdit(false);
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </div>
                  ) : null}
                </Grid.Column>
              </Grid>
              <hr />
              <div
                className="customer-form-content"
                style={{ paddingRight: "0px !important" }}
              >
                <Form size="tiny">
                  <Grid>
                    <Grid.Row style={{ paddingBottom: 0 }}>
                      {formData?.id !== -1 ? (
                        <>
                          {" "}
                          <Grid.Column
                            width={1}
                            style={{
                              paddingTop: 17,
                              paddingBottom: "1rem",
                              paddingRight: 0,
                            }}
                          >
                            <Image
                              width={18}
                              src={rightArrow}
                              wrapped
                              style={{ marginTop: -8.5 }}
                            />
                          </Grid.Column>
                          <Grid.Column
                            width={15}
                            style={{
                              paddingTop: "1rem",
                              paddingBottom: "1rem",
                            }}
                          >
                            <Header
                              as="h5"
                              style={{
                                marginLeft: -15,
                                fontSize: 18,
                                marginLeft: -35,
                              }}
                            >
                              Customer Details
                            </Header>
                          </Grid.Column>
                          <Grid.Column
                            width={16}
                            style={{
                              minHeight: 220,
                              padding: 0,
                              paddingTop: 15,
                              pointerEvents: onCustomerEdit ? "" : "none",
                              opacity: onCustomerEdit ? 1 : 0.75,
                            }}
                          >
                            <Grid
                              style={{
                                marginLeft: 0,
                                marginRight: 20,
                              }}
                            >
                              <Grid.Row style={{ padding: 5, paddingTop: 10 }}>
                                <Grid.Column width={8}>
                                  <span
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 16,
                                    }}
                                  >
                                    Labour Fee
                                  </span>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                  <span
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 16,
                                    }}
                                  >
                                    Travel Fee
                                  </span>
                                </Grid.Column>
                                <Grid.Column
                                  width={16}
                                  style={{ paddingRight: 0 }}
                                ></Grid.Column>
                              </Grid.Row>
                              <Grid.Row style={{ padding: 5 }}>
                                <Grid.Column width={8}>
                                  <Checkbox
                                    radio
                                    label="Use Global Value"
                                    checked={formData?.useGlobalLabour}
                                    value={formData?.useGlobalLabour}
                                    onClick={() =>
                                      handleChange("useGlobalLabour", true)
                                    }
                                  />
                                  <Checkbox
                                    radio
                                    label="Set ($/hr)"
                                    style={{ paddingLeft: "1.5rem" }}
                                    checked={!formData?.useGlobalLabour}
                                    onClick={() =>
                                      handleChange("useGlobalLabour", false)
                                    }
                                  />
                                  {!dataLoading ? (
                                    <Input
                                      className={
                                        customerSaved &&
                                        !formData.useGlobalLabour &&
                                        (formData.labourFee === "" ||
                                          formData.labourFee === null)
                                          ? "error"
                                          : ""
                                      }
                                      disabled={formData?.useGlobalLabour}
                                      style={{ paddingLeft: 10, width: "30%" }}
                                      defaultValue={formData?.labourFee}
                                      onBlur={(e) =>
                                        handleChange(
                                          "labourFee",
                                          e.target.value
                                        )
                                      }
                                      onKeyDown={(event) =>
                                        NumericInputChecker(event, 2)
                                      }
                                    />
                                  ) : (
                                    <Input
                                      disabled
                                      style={{ paddingLeft: 10, width: "30%" }}
                                    />
                                  )}
                                </Grid.Column>
                                <Grid.Column width={8}>
                                  <Checkbox
                                    radio
                                    label="Use Global Value"
                                    checked={formData?.useGlobalTravel}
                                    value={formData?.useGlobalTravel}
                                    onClick={() =>
                                      handleChange("useGlobalTravel", true)
                                    }
                                  />
                                  <Checkbox
                                    radio
                                    label="Set ($/hr)"
                                    style={{ paddingLeft: "1.5rem" }}
                                    checked={!formData?.useGlobalTravel}
                                    onClick={() =>
                                      handleChange("useGlobalTravel", false)
                                    }
                                  />
                                  {!dataLoading ? (
                                    <Input
                                      className={
                                        customerSaved &&
                                        !formData.useGlobalTravel &&
                                        (formData.travelFee === "" ||
                                          formData.travelFee === null)
                                          ? "error"
                                          : ""
                                      }
                                      disabled={formData?.useGlobalTravel}
                                      style={{ paddingLeft: 10, width: "30%" }}
                                      defaultValue={formData?.travelFee}
                                      onBlur={(e) =>
                                        handleChange(
                                          "travelFee",
                                          e.target.value
                                        )
                                      }
                                      onKeyDown={(event) =>
                                        NumericInputChecker(event, 2)
                                      }
                                    />
                                  ) : (
                                    <Input
                                      disabled
                                      style={{ paddingLeft: 10, width: "30%" }}
                                    />
                                  )}
                                </Grid.Column>
                              </Grid.Row>
                              <Grid.Row style={{ padding: 5, paddingTop: 40 }}>
                                <Grid.Column width={8}>
                                  <span
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 16,
                                    }}
                                  >
                                    Customer Specific Mark-up
                                  </span>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                  <span
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 16,
                                    }}
                                  >
                                    Customer Discount
                                  </span>
                                </Grid.Column>
                                <Grid.Column
                                  width={16}
                                  style={{ paddingRight: 0 }}
                                ></Grid.Column>
                              </Grid.Row>
                              <Grid.Row style={{ padding: 5 }}>
                                <Grid.Column width={8}>
                                  <Checkbox
                                    radio
                                    label="Use Global Value"
                                    checked={formData?.useGlobalMarkup}
                                    value={formData?.useGlobalMarkup}
                                    onClick={() =>
                                      handleChange("useGlobalMarkup", true)
                                    }
                                  />
                                  <Checkbox
                                    radio
                                    label="Set %"
                                    style={{
                                      paddingLeft: "1.5rem",
                                      width: 103,
                                    }}
                                    checked={!formData?.useGlobalMarkup}
                                    onClick={() =>
                                      handleChange("useGlobalMarkup", false)
                                    }
                                  />
                                  {!dataLoading ? (
                                    <Input
                                      className={
                                        customerSaved &&
                                        !formData.useGlobalMarkup &&
                                        (formData.markupPercent === "" ||
                                          formData.markupPercent === null)
                                          ? "error"
                                          : ""
                                      }
                                      label={{
                                        basic: true,
                                        content: "%",
                                      }}
                                      labelPosition="right"
                                      disabled={formData?.useGlobalMarkup}
                                      style={{ paddingLeft: 20, width: "25%" }}
                                      defaultValue={formData?.markupPercent}
                                      onBlur={(e) =>
                                        handleChange(
                                          "markupPercent",
                                          e.target.value
                                        )
                                      }
                                      onKeyDown={(event) =>
                                        NumericInputChecker(event, 1)
                                      }
                                    />
                                  ) : (
                                    <Input
                                      label={{
                                        basic: true,
                                        content: "%",
                                      }}
                                      labelPosition="right"
                                      disabled
                                      style={{ paddingLeft: 20, width: "25%" }}
                                    />
                                  )}
                                </Grid.Column>
                                <Grid.Column
                                  width={3}
                                  style={{ paddingRight: 60 }}
                                >
                                  <DiscountInput />
                                </Grid.Column>
                              </Grid.Row>
                              <Grid.Row
                                style={{
                                  padding: 5,
                                  paddingTop: 20,
                                  paddingBottom: 40,
                                }}
                              >
                                <Grid.Column width={4}>
                                  <span
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 16,
                                    }}
                                  >
                                    Required Purchase Order (PO) Number
                                  </span>
                                </Grid.Column>
                                <Grid.Column
                                  width={4}
                                  style={{ paddingTop: 12 }}
                                >
                                  <Checkbox
                                    toggle
                                    style={{
                                      marginLeft: 15,
                                    }}
                                    checked={
                                      formData.requirePurchaseOrderNumber
                                    }
                                    onChange={(e, data) =>
                                      handleChange(
                                        "requirePurchaseOrderNumber",
                                        data.checked
                                      )
                                    }
                                  />
                                </Grid.Column>
                                {localStorage.getItem("isXeroConnected") ===
                                  "true" && (
                                  <>
                                    <Grid.Column width={4}>
                                      <span
                                        style={{
                                          fontWeight: "bolder",
                                          fontSize: 16,
                                        }}
                                      >
                                        Show Hose Assembly Details in Xero
                                        Invoice
                                      </span>
                                    </Grid.Column>
                                    <Grid.Column
                                      width={4}
                                      style={{ paddingTop: 12 }}
                                    >
                                      <Checkbox
                                        toggle
                                        style={{
                                          marginLeft: 15,
                                        }}
                                        checked={formData.showItemizedInvoice}
                                        onChange={(e, data) =>
                                          handleChange(
                                            "showItemizedInvoice",
                                            data.checked
                                          )
                                        }
                                      />
                                    </Grid.Column>
                                  </>
                                )}
                              </Grid.Row>
                            </Grid>
                          </Grid.Column>
                        </>
                      ) : null}
                      <Grid.Column
                        width={1}
                        style={{
                          paddingTop: 17,
                          paddingBottom: "1rem",
                          paddingRight: 0,
                        }}
                      >
                        <Image
                          width={18}
                          src={rightArrow}
                          wrapped
                          style={{ marginTop: -8.5 }}
                        />
                      </Grid.Column>
                      <Grid.Column
                        width={15}
                        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
                      >
                        <Header
                          as="h5"
                          style={{
                            marginLeft: -15,
                            fontSize: 18,
                            marginLeft: -35,
                          }}
                        >
                          Contacts
                        </Header>
                      </Grid.Column>
                      <Grid.Column
                        width={16}
                        style={{
                          padding: 0,
                          paddingTop: 15,
                        }}
                      >
                        <Grid
                          style={{
                            marginLeft: 0,
                            marginRight: 20,
                          }}
                        >
                          <Grid.Row style={{ padding: 5 }}>
                            <Grid.Column width={5} style={{ paddingTop: 7.5 }}>
                              <span
                                style={{
                                  fontWeight: "bolder",
                                  fontSize: 14,
                                }}
                              >
                                Contact Name
                              </span>
                            </Grid.Column>
                            <Grid.Column width={5} style={{ paddingTop: 7.5 }}>
                              <span
                                style={{
                                  fontWeight: "bolder",
                                  fontSize: 14,
                                }}
                              >
                                Phone Number
                              </span>
                            </Grid.Column>
                            <Grid.Column width={3} style={{ paddingTop: 7.5 }}>
                              <span
                                style={{
                                  fontWeight: "bolder",
                                  fontSize: 14,
                                }}
                              >
                                Contact Email
                              </span>
                            </Grid.Column>
                            <Grid.Column width={3}>
                              {formData.id > 0 ? (
                                <Button
                                  className="active-status"
                                  size="mini"
                                  style={{
                                    width: "100%",
                                  }}
                                  onClick={() => {
                                    setContactFormData({
                                      customerId: formData.id,
                                      companyName: formData.companyName,
                                    });
                                    setIsAddContactFromCustomer(true);
                                    setIsAddCompany(false);
                                    setContactSaved(false);
                                    setOnCustomerEdit(false);
                                    setAddContactOpen(true);
                                  }}
                                >
                                  <Icon name="add" style={{ color: "#fff" }} />
                                  Add New Contact
                                </Button>
                              ) : null}
                            </Grid.Column>
                            <Grid.Column width={16} style={{ paddingRight: 0 }}>
                              <hr />
                            </Grid.Column>
                          </Grid.Row>
                          {formData?.customerContacts?.length > 0 ? (
                            <>
                              {formData?.customerContacts?.map(
                                (contact, index) => {
                                  return (
                                    <Grid.Row
                                      columns={4}
                                      style={{ padding: 5, fontSize: 15 }}
                                    >
                                      <Grid.Column width={5}>
                                        <span>{contact?.contactName}</span>
                                      </Grid.Column>
                                      <Grid.Column width={5}>
                                        <span>{contact?.contactNumber}</span>
                                      </Grid.Column>
                                      <Grid.Column
                                        width={4}
                                        style={{ paddingRight: 0 }}
                                      >
                                        <span>{contact?.email}</span>
                                      </Grid.Column>
                                      <Grid.Column width={2}>
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 1,
                                            right: 15,
                                          }}
                                        >
                                          <Icon
                                            style={{ marginRight: 8 }}
                                            link
                                            name="pencil"
                                            onClick={() => {
                                              setContactFormData(contact);
                                              setTimeout(() => {
                                                setAddContactOpen(true);
                                              }, 300);
                                            }}
                                          />
                                          <Icon
                                            link
                                            name="trash"
                                            style={{ color: "red" }}
                                            onClick={() => {
                                              setSelectedContact(contact);
                                              setOpenRemoveContact(true);
                                            }}
                                          />
                                        </div>
                                      </Grid.Column>
                                    </Grid.Row>
                                  );
                                }
                              )}
                            </>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                                paddingTop: 40,
                                paddingRight: 250,
                                color: "#AFABAB",
                                fontSize: 22,
                              }}
                            >
                              <span>No Contacts Found</span>
                            </div>
                          )}
                        </Grid>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form>
              </div>
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    userInfo: state.auth.user,
  };
};

const reducer = { ...cartReducer, ...searchReducer };

const mapDispatchToProps = (dispatch) => bindActionCreators(reducer, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StockTransfer);
